import { officeProductOfferConstants as C } from '../actions/constants'

const initialState = {
    offers: [],
    enabled: [],
    offerMap: {},
    loading: false,
    saving: false,
    lastTouchedProductId: null,
    error: null,
}

const buildOfferMap = (offers) => {
    const map = {}

        ; (offers || []).forEach((offer) => {
            const productId = offer?.productId?._id || offer?.productId

            if (productId) {
                map[String(productId)] = offer
            }
        })

    return map
}

const mergeOffer = (list, offer) => {
    if (!offer?._id) return list

    const next = [...(list || [])]
    const index = next.findIndex((item) => String(item._id) === String(offer._id))

    if (index >= 0) {
        next[index] = offer
    } else {
        next.unshift(offer)
    }

    return next
}

const officeProductOfferReducer = (state = initialState, action) => {
    switch (action.type) {
        case C.LIST_REQUEST:
        case C.ENABLED_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            }

        case C.ADD_REQUEST:
        case C.UPDATE_REQUEST:
        case C.REMOVE_REQUEST:
            return {
                ...state,
                saving: true,
                lastTouchedProductId: action.meta?.productId || null,
                error: null,
            }

        case C.LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                offers: action.payload || [],
                offerMap: buildOfferMap(action.payload || []),
            }

        case C.ENABLED_SUCCESS:
            return {
                ...state,
                loading: false,
                enabled: action.payload || [],
            }

        case C.ADD_SUCCESS:
        case C.UPDATE_SUCCESS:
        case C.REMOVE_SUCCESS: {
            const offers = mergeOffer(state.offers, action.payload)

            return {
                ...state,
                saving: false,
                lastTouchedProductId: null,
                offers,
                offerMap: buildOfferMap(offers),
            }
        }

        case C.LIST_FAILURE:
        case C.ENABLED_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            }

        case C.ADD_FAILURE:
        case C.UPDATE_FAILURE:
        case C.REMOVE_FAILURE:
            return {
                ...state,
                saving: false,
                lastTouchedProductId: null,
                error: action.payload,
            }

        default:
            return state
    }
}

export default officeProductOfferReducer